export default "__VITE_ASSET__DtuXl1nY__"